import { component } from 'picoapp';
import Lightbox from 'utils/lightbox';

export default component((node, ctx) => {
  Lightbox(node, ctx);
});
